import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";

import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";


const styles = () => ({
  buttons: {
    marginTop: "24px",
    display: "flex",
    justifyContent: "flex-end",
  },
  focused: {}, // material ui sucks, so this empty object is 100% necessary
});

export const NoVehiclesModal = (props) => {
  const { modalOpen, handleModalClose, t } = props;

  const closeModal = () => {
    handleModalClose();
  };

  return (
    <Dialog
      open={modalOpen}
      onClose={handleModalClose}
      aria-labelledby="no-vehicles-modal"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <div>{t("Ota.NoVehicles")}</div>
        <Typography>
          {t("Ota.PleaseSelectVehicles")}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <div className={props.classes.buttons}>
          <Button variant="outlined" onClick={closeModal}>
            {t("Ota.Modals.Close")}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

NoVehiclesModal.propTypes = {
  t: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  handleModalClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation("common")(withStyles(styles)(NoVehiclesModal));
